// extracted by mini-css-extract-plugin
module.exports = {"image-container":"full_width_image_style_image-container__2oOgx","image":"full_width_image_style_image__3hWUl"};